module.exports = __webpack_public_path__ + "static/media/csv.baf766ed.svg";